import React, {Component} from 'react'
import {Button} from "antd"
import {exportItemCsv} from "../../../../services/api/3dApi"
import {createJobExport} from '../../../../helpers/createJobExport'
import downloadFileFromData from '../../../../helpers/downloadFileFromData'
import moment from 'moment'
class ExportBatchCSV extends Component {
    _handleExportCSV = async () => {
        const {match, status} = this.props
        try {
            const {data: res} = await exportItemCsv(match.params.id, `status=${status}`)
            if(typeof res !== 'string'){
                const { success, message: mess, data } = res
                if(!success) throw new Error(mess)
            
                if(Object.keys(data).length > 0) {
                    createJobExport(data)
                }
            }else{
                if(res) downloadFileFromData(res, { filename: `Batch-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            }
        } catch (error) {
            console.log(error.message)
        }
    }

    render() {
        const {changeContent} = this.props

        return (
            <Button type="primary" icon='export' className="mr-3 mt-2"
                    disabled={changeContent}
                    onClick={this._handleExportCSV}>Xuất CSV</Button>
        )
    }

}

export default ExportBatchCSV
